export default __webpack_public_path__ + "./images/noCover.d7eef433.svg";